<template>
  <div :class="{ 'mobile-preview-section': isMobile600, 'preview-section': !isMobile600 }">
    <v-flex :class="{'d-flex justify-space-between align-end': !isMobile960, 'd-flex flex-column': isMobile960}">
      <span :class="{'help-text': !isMobile960, 'help-text my-2': isMobile960}">Drag and drop to rearrange</span>
      <v-btn class="clear-btn" depressed small @click="deleteAll">Clear All</v-btn>
    </v-flex>
    <div class="preview-bg">
      <draggable :list="componentList" group="componentList" @start="drag=true" @end="drag=false">
        <v-layout row v-for="component in componentList" :key="component.id">
          <v-flex xs12 class="img-container">
            <v-btn @click="deleteComponent(component)" absolute small fab top right>
                <v-icon>delete</v-icon>
              </v-btn>
            <v-img width="100%" :src="imagePreview(component)"></v-img>
          </v-flex>
        </v-layout>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable';
import screenMixin from '../mixins/screenMixin';

export default {
  mixins: [screenMixin],
  computed: {
      ...mapGetters(
      ['imagePreview']
  ),
    componentList: {
        get() {
            return this.$store.state.chosenComponents
        },
        set(value) {
            this.$store.commit('updateList', value)
        }
    },
  },
  methods: {
    deleteComponent(piece) {
      for (var i = 0; i < this.$store.state.chosenComponents.length; i++) {
        if (this.$store.state.chosenComponents[i] === piece) {
          this.$store.state.chosenComponents.splice(i,1);
        }
      }
    },
    deleteAll() {
      this.$store.state.chosenComponents = [];
    },
  },
  components: {
    draggable
  }
}

</script>

<style scoped>
  .preview-section {
    position: fixed;
    top: 80px;
    bottom: 0;
    right: 24px;
    left: 75%;
  }
  .preview-bg {
    border: 2px solid #006aff;
    border-radius: 9px;
    background: #f9f9f9;
    box-shadow: 0px 3px 10px 4px rgb(0 106 255 / 10%), 0px 2px 2px 0px rgb(0 83 199 / 10%), 0px 1px 5px 0px rgb(0 83 199 / 9%);
    width: 100%;
    margin: 10px auto;
    overflow-y: scroll;
    height: 80vh;
    position: relative;
  }
  .img-container {
    position: relative;
  }
  .img-container button {
    height: 20px;
    width: 20px;
    top: 5px !important;
  }
  .help-text {
    color: #006aff;
  }
  .flex-column {
    flex-direction: column;
  }
  .preview-bg::-webkit-scrollbar {
    scrollbar-width: thin;
  }
  .preview-bg::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 9px;
    margin: 1px;
  }
  .preview-bg::-webkit-scrollbar-thumb {
    background: #c7c7c7;
    border-radius: 9px;
    border: 2px solid transparent;
    background-clip: padding-box;
  }
  .preview-bg::-webkit-scrollbar-thumb:hover {
    background: #555;
    background-clip: padding-box;
  }

</style>
